export class ContentLibraryUtils {
    static convertRuleValueToStringArray(val?: string | null): string[] {
        if (!val) {
            return [];
        }
        try {
            const parsed = JSON.parse(val);
            if (Array.isArray(parsed)) {
                return parsed;
            }
        } catch (error) {}

        return val.split(',');
    }
}
